import { render, staticRenderFns } from "./KelasRS.vue?vue&type=template&id=1d924c2c"
import script from "./KelasRS.vue?vue&type=script&lang=js"
export * from "./KelasRS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports